<template>
  <div>
    <hnavbar />
    <Content pagetitle="WELCOME TO HARBOUR CITY APPLICATION PORTAL">
      <box boxheading="CHOOSE ANY OF THE APPLICATION FORM TO APPLY">
        <img src="assets/images/why.png" alt="" style="max-width: 100%" />
        <br />
        <br />
        <router-link to="/wassce">
          <div class="alert alert-info alert-dismissible">
            <h1>WASSCE APPLICATION FORM</h1>
          </div></router-link
        >

        <router-link to="/professional"><div class="alert alert-info alert-dismissible">
            <h1>PROFESSIONAL APPLICATION FORM</h1>
          </div></router-link
        >

        <router-link to="/special">
          <div class="alert alert-info alert-dismissible">
            <h1>SPECIAL PROGRAMME ADMISSION FORM</h1>
          </div></router-link
        >
      </box>
    </Content>
  </div>
</template>

<script>
import hnavbar from "../components/HNavBar.vue";
import Content from "../components/Content.vue";
import Box from "../components/Box.vue";
export default {
  name: "Home",
  components: {
    hnavbar,
    Content,
    Box,
  },
};
</script>

<style lang="scss" scoped></style>
